import { render } from "./LeakRuleForm.vue?vue&type=template&id=576f0bc2"
import script from "./LeakRuleForm.vue?vue&type=script&lang=js"
export * from "./LeakRuleForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__